/* Diffs and file contents. The diff colours are the semantic diff tokens, so
 * both themes and the colour-blind-safe palette apply. */

.scroll {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-family: var(--font-family-mono);
  font-size: var(--text-sm);
  line-height: 1.5;
}

.number {
  width: 1%;
  min-width: 3rem;
  padding: 0 var(--space-3);
  text-align: right;
  color: var(--color-text-tertiary);
  user-select: none;
  vertical-align: top;
  white-space: nowrap;
}

.marker {
  width: 1%;
  padding: 0 var(--space-1);
  color: var(--color-diff-gutter-text);
  user-select: none;
}

.text {
  padding: 0 var(--space-4) 0 var(--space-1);
  white-space: pre;
  color: var(--color-text-primary);
}

.added {
  background: var(--color-diff-added-bg);
}

.removed {
  background: var(--color-diff-removed-bg);
}

.hunk {
  background: var(--color-diff-context-bg);
  color: var(--color-text-secondary);
}

.notice {
  margin: 0;
  padding: var(--space-4);
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
